import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import About from "@/components/landing/About";
import ForWhom from "@/components/landing/ForWhom";
import Services from "@/components/landing/Services";
import Method from "@/components/landing/Method";
import Protocol from "@/components/landing/Protocol";
import Testimonials from "@/components/landing/Testimonials";
import Faith from "@/components/landing/Faith";
import Locations from "@/components/landing/Locations";
import LeadForm from "@/components/landing/LeadForm";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";

const LandingPage = () => {
  return (
    <main className="bg-[#FDFBF7]" data-testid="landing-page">
      <Navbar />
      <Hero />
      <About />
      <ForWhom />
      <Services />
      <Method />
      <Protocol />
      <Testimonials />
      <Faith />
      <Locations />
      <LeadForm />
      <FAQ />
      <FinalCTA />
      <Footer />
    </main>
  );
};

export default LandingPage;
